// Reps : l'icône d'un parcours, façon icône d'app iOS (carré 1:1, coins
// "squircle" via un rayon proportionnel ~22% du côté).
//
// Aucun parcours n'a encore d'illustration dédiée en base : on rend donc un
// PLACEHOLDER sobre (tuile douce + glyphe estompé) plutôt qu'un vrai visuel.
// Le jour où le back renverra une image par parcours, il suffira de brancher
// `src` ici sans toucher aux appelants (catalogue + widget).
import SolarIcon from "@/components/ui/SolarIcon/SolarIcon";

// Teinte douce dérivée de la couleur du parcours (hex #RRGGBB uniquement :
// toute autre valeur retombe sur le placeholder gris, plutôt que de produire
// une couleur invalide).
const HEX = /^#[0-9a-f]{6}$/i;

export default function RepsIcon({
    size = 56,
    src = null,
    alt = "",
    color = null,
    className = "",
}) {
    const radius = Math.round(size * 0.2237); // proportion d'une icône iOS
    const glyph = Math.round(size * 0.46);
    const tint = !src && color && HEX.test(color) ? color : null;

    return (
        <span
            aria-hidden={src ? undefined : "true"}
            style={{
                width: size,
                height: size,
                borderRadius: radius,
                ...(tint ? { backgroundColor: `${tint}1F` } : null),
            }}
            className={`relative flex shrink-0 items-center justify-center overflow-hidden ring-1 ring-inset ring-black/[0.04] dark:ring-white/[0.06] ${
                tint
                    ? ""
                    : "bg-gradient-to-br from-gray-100 to-gray-200/70 dark:from-white/[0.09] dark:to-white/[0.03]"
            } ${className}`}
        >
            {src ? (
                // eslint-disable-next-line @next/next/no-img-element
                <img
                    src={src}
                    alt={alt}
                    width={size}
                    height={size}
                    className="h-full w-full object-cover"
                />
            ) : (
                <SolarIcon
                    name="code-square-bold-duotone"
                    className={tint ? "" : "text-gray-300 dark:text-white/25"}
                    style={{
                        fontSize: glyph,
                        ...(tint ? { color: tint } : null),
                    }}
                />
            )}
        </span>
    );
}
